module.exports = __webpack_public_path__ + "static/media/clock.4b0f830c.svg";